import React, { Fragment, useMemo, useState } from "react"

import { useTranslation } from "react-i18next"

import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Grid } from "@mui/material"
import { Menu, MenuItem, Typography } from "@synapse-analytics/synapse-ui"

import { LANGUAGES } from "../Constants"

import styles from "./DashboardDrawer.module.scss"

type LanguageCode = keyof typeof LANGUAGES

export function LanguageSelect(): React.ReactElement {
  const { i18n } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const currentLang: LanguageCode = useMemo(() => {
    const lang = i18n.resolvedLanguage || i18n.language || "en"
    return lang as LanguageCode
  }, [i18n.resolvedLanguage, i18n.language])

  const SelectedIcon = LANGUAGES[currentLang].icon
  const isOpen = Boolean(anchorEl)

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = (): void => {
    setAnchorEl(null)
  }

  const handleSelect = (lng: LanguageCode): void => {
    if (lng !== currentLang) {
      i18n.changeLanguage(lng)
    }
    handleClose()
  }

  const menuItems = (Object.keys(LANGUAGES) as LanguageCode[]).map((langCode) => {
    const { icon: Icon, label } = LANGUAGES[langCode]
    return (
      <MenuItem
        className={styles.langMenuItem}
        key={langCode}
        onClick={() => handleSelect(langCode)}
        isSelected={currentLang === langCode}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="label-bold">{label}</Typography>
          <Icon width="14" height="14" />
        </Grid>
      </MenuItem>
    )
  })

  return (
    <Fragment>
      <Grid className={styles.selectLangBtn} onClick={handleOpenMenu}>
        <SelectedIcon width="14" height="14" />
        {isOpen ? <ExpandLess color="inherit" fontSize="inherit" /> : <ExpandMore color="inherit" fontSize="inherit" />}
      </Grid>

      <Menu maxWidth={120} id="menu-select-lng" anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        {menuItems}
      </Menu>
    </Fragment>
  )
}
